
import { useEffect, useState } from "react";
import { LoginHelper } from "../../../../utils/LoginHelper";
import { api } from "../../../../utils/api";
import Selector from "../../common/selector/Selector";
import Day from "./Day";

export default function VisitSection({ isDesktop, doctorId }) {
	const [days, setDays] = useState([]);
	const [selectedDay, setSelectedDay] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchDays();
	}, []);

	function fetchDays() {
		api.visitUserViewDayVisits({
			token: LoginHelper.getToken(),
			doctor_profile_id: doctorId,
		}).then((results) => {
			setDays(results);
			initSelectedDay(results);
		}).catch((err) => {
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	function initSelectedDay(days) {
		const today = days.find(day => day.is_today);
		if (today) {
			setSelectedDay(today);
		}
	}

	function handleSelectDay(dayId) {
		const day = days.find(currentDay => currentDay.id === dayId);
		if (day) {
			setSelectedDay(day);
		}
	}

	function handleToggleVisitReserve(dayId, startDatetime, isReserve, isProfileOwner) {
		const day = days.find(currentDay => currentDay.id === dayId);
		if (day) {
			for (let visit of day.visit_data_list) {
				if (visit.start_datetime === startDatetime) {
					visit.is_reserve = isReserve;
					visit.is_profile_owner = isProfileOwner;
					break;
				}
			}
		}
	}

	return (
		<div>
			{days && (
				<Selector isDesktop={isDesktop} days={days} selectedDay={selectedDay} onSelectDay={handleSelectDay} />
			)}
			<div className="spacer p-[10px]"></div>
			{selectedDay && (
				<Day key={selectedDay.id} isDesktop={isDesktop} doctorId={doctorId} day={selectedDay} onToggleVisitReserve={handleToggleVisitReserve} />
			)}
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</div>
	)
}
